import { TypedDocumentNode, gql } from '@apollo/client';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';
import { fantasy } from '@sorare/core/src/lib/glossary';
import { useTypedParams } from '@sorare/core/src/lib/routing';

import { RewardsBanner } from '@sorare/gameplay/src/components/rewards/RewardBanner';

import { ClubLayout } from '@sorare/manager/src/components/profile/ClubLayout';

import {
  BaseballProHistoryLayoutQuery,
  BaseballProHistoryLayoutQueryVariables,
} from './__generated__/layout.graphql';
import { LayoutParams } from './__generated__/routeParams';

const PRO_HISTORY_LAYOUT_QUERY = gql`
  query BaseballProHistoryLayoutQuery {
    currentUser {
      slug
      unclaimedSo5Rewards(sport: BASEBALL) {
        slug
        ...RewardsBanner_so5Reward
      }
    }
  }
  ${RewardsBanner.fragments.so5Reward}
` as TypedDocumentNode<
  BaseballProHistoryLayoutQuery,
  BaseballProHistoryLayoutQueryVariables
>;

const StyledVertical = styled(Vertical)`
  padding: var(--double-unit) 0;
`;

const HistoryLayout = () => {
  const { slug } = useTypedParams<LayoutParams>();
  const { currentUser } = useCurrentUserContext();

  const isMe = slug === currentUser?.slug;

  const { data } = useQuery(PRO_HISTORY_LAYOUT_QUERY);

  return (
    <ClubLayout home>
      <PageHeader text={fantasy.proHistory} />
      <StyledVertical gap={2}>
        {isMe && data?.currentUser?.unclaimedSo5Rewards && (
          <RewardsBanner rewards={data.currentUser.unclaimedSo5Rewards} />
        )}
        <Outlet />
      </StyledVertical>
    </ClubLayout>
  );
};

export default HistoryLayout;
